import React, { useEffect, useRef } from "react";
import translate from "@deosite/helpers/langLibrary";

import Container from "@commerce-ui/core2/Container";

import PageContainer from "../../containers/UI/PageContainer";

import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";

import InspirationCard from "../../components/InspirationCard";
import Grid2Cards from "../../sections/Grid2Cards";
import CategoriesTagsSlider from "../../sections/CategoriesTagsSlider";

const InspirationsListPage = props => {
  const {
    backLabel,
    backClickFunction,
    inspirations,
    categoryName,
    dataRequiredToHideLoader,
    subcategories,
    footerContent
  } = props;

  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title"),
    peopleLiked: translate("People also liked")
  };

  return (
    <PageContainer
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
      footerContent={footerContent}
    >
      <SectionWithConfigurableHeader title={categoryName}>
        <Container>
          <CategoriesTagsSlider categories={subcategories} />
        </Container>
        <Container margin={[0, null, null, "s13"]}>
          {inspirations && (
            <Grid2Cards>
              {inspirations.map(
                (inspiration, index) =>
                  inspiration && (
                    <InspirationCard key={index} inspiration={inspiration} />
                  )
              )}
            </Grid2Cards>
          )}
        </Container>
      </SectionWithConfigurableHeader>
    </PageContainer>
  );
};

export default InspirationsListPage;
